export class DateAuditoriaModel {
    Id: number;
    Desde: Date;
    Hasta: Date;
}